import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = true;
Vue.config.silent = false;

window.qs = require("qs");
window.moment = require("moment");
window.Sticky = require("sticky-js");
window.Timer = require("easytimer.js").Timer;
window.currency = require("currency.js");

require("moment-duration-format");

window.moment.locale("ru");

const VueCtkDateTimePicker = () => import("vue-ctk-date-time-picker");

import Auth from "./packages/auth/Auth";
import Convert from "./packages/convert/Convert";
import OnlineToken from "./packages/online-token/OnlineToken";
import VueRouter from "vue-router";
import Vuetify from "vuetify/lib";
import routes from "./router/index";
import store from "./store/index";
import Notifications from "vue-notification";
import InfiniteLoading from "vue-infinite-loading";
import vuexI18n from "vuex-i18n";
import Vocabulary from "@/vocabulary";
import {
  VTooltip
} from "v-tooltip";
window.Vocabulary = Vocabulary;

import ResizeSensor from "resize-sensor";
window.ResizeSensor = ResizeSensor;

import "vuetify/dist/vuetify.min.css";
import "bootstrap-4-grid/css/grid.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import "@/scss/app.scss";

import Api from "@/api/base";

Api.init(process.env.VUE_APP_API_HOST);

Vue.use(VueRouter);
Vue.use(Auth);
Vue.use(Convert);
Vue.use(OnlineToken);
Vue.use(InfiniteLoading);
Vue.use(Notifications);
Vue.use(vuexI18n.plugin, store, {
  onTranslationNotFound(locale, key) {
    return key ? key.split(".")[1] : '';
  },
});
Vue.use(Vuetify, {
  theme: {
    success: "#17cf72",
    primary: "#206dfb",
    accent: "#206dfb",
  },
  icons: {
    dropdown2: "keyboard_arrow_down",
  },
});
Vue.component("vue-ctk-date-time-picker", VueCtkDateTimePicker);
Vue.directive("tooltip", VTooltip);

let router = new VueRouter(routes);

function isIframeQueries(to) {
  const {
    name
  } = to;

  if (
      name === "get-iframe" ||
      name === "iframe" ||
      name === "genesys" ||
      name === 'create-order' ||
      name === 'operator-error'
  ) {
    return true;
  }

  return false;
}

function isInfoPageQueries(path) {
  if (
    path === "/" ||
    path === "/login" ||
    path === "/infopage" ||
    path === "/infopage/companies" ||
    path === "/infopage/native-speakers" ||
    path === "/infopage/contacts" ||
    path === "/infopage/privacy" ||
    path === "/infopage/terms" ||
    path === "/infopage/password-recovery"
  ) {
    return true;
  }

  return false;
}

router.beforeEach(async (to, from, next) => {
  if (isIframeQueries(to)) {
    Vue.auth.destroyToken();
    next();
  } else if (isInfoPageQueries(to.path)) {
    if (!Vue.auth.isAuthenticated()) {
      next();
    } else {
      router.push("/dashboard");
    }
  } else {
    if (Vue.auth.isAuthenticated()) {
      next();
    } else {
      router.push("/infopage");
    }
  }
});

new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});